import { Event, EVENTS_FILTER_KEYS, GetEventsQueryFilters, useGetEventsQuery } from '@schooly/api';
import { FC, useCallback, useMemo } from 'react';

import { pickOnlyParamsFromFilterKeys } from '../../utils';
import { EventRecurrenceLabelSelect } from '../RecurrenceLabelSelect/EventRecurrenceSelectLabel';
import { getRecurrences } from '../utils';
import { RecurrenceExpandedSelect } from './RecurrenceExpandedSelect';

type EventRecurrenceExpandedSelectProps = {
  schoolId: string;
  selectedId: string;
  onSelectRecurrence: (v: string) => void;
  onClear: () => void;
  onClose: () => void;
  filters?: GetEventsQueryFilters;
};
export const EventRecurrenceExpandedSelect: FC<EventRecurrenceExpandedSelectProps> = ({
  schoolId,
  filters = {},
  selectedId,
  ...selectProps
}) => {
  const { data, hasNextPage, params, setParams, isLoading, isFetchingNextPage, fetchNextPage } =
    useGetEventsQuery(
      {
        schoolId,
        query: '',
        filters: pickOnlyParamsFromFilterKeys(EVENTS_FILTER_KEYS, filters),
      },
      {
        refetchOnMount: 'always',
      },
    );

  const handleChangeQuery = useCallback(
    (query: string) => {
      setParams((p) => ({ ...p, query }));
    },
    [setParams],
  );

  const events = useMemo(
    () => data?.pages.reduce<Event[]>((prev, curr) => [...prev, ...curr.results], []) ?? [],
    [data?.pages],
  );
  const recurrences = getRecurrences(events);

  const renderLabel = useCallback(
    (title: string) => {
      return <EventRecurrenceLabelSelect title={title} id={selectedId} schoolId={schoolId} />;
    },
    [schoolId, selectedId],
  );

  return (
    <RecurrenceExpandedSelect
      {...selectProps}
      schoolId={schoolId}
      recurrences={recurrences}
      isLoading={isLoading || isFetchingNextPage}
      fetchNextPage={fetchNextPage}
      handleChangeQuery={handleChangeQuery}
      hasNextPage={hasNextPage}
      query={params.query}
      renderLabel={renderLabel}
      selectedId={selectedId}
    />
  );
};
